import React, { Component, Fragment } from 'react';
import { localize } from 'react-localize-redux';
import { withStyles } from '@material-ui/core/styles';
import ExpansionPanel from '@material-ui/core/ExpansionPanel';
import ExpansionPanelSummary from '@material-ui/core/ExpansionPanelSummary';
import ExpansionPanelDetails from '@material-ui/core/ExpansionPanelDetails';
import FlatButton from 'material-ui/FlatButton';
import { MdKeyboardArrowDown as DownArrow } from 'react-icons/md';
import { MdKeyboardArrowUp as UpArrow } from 'react-icons/md';

import { colors } from 'helpers/ColorHelper';
import { AccentColor } from 'helpers/AccentColorHelper';
import MultiSelectExtended from 'components/shared/MultiSelectExtended';
import styled from 'styled-components';

const BodyContent = styled.div`
  overflow-y: scroll;
  height: inherit;
`;

const styles = {
  sectionHeader: {
    backgroundColor: '#f1f1f1',
    padding: '5px 10px',
    fontSize: '14px',
    fontWeight: '800',
    color: 'rgba(78, 78, 78, 0.6)',
    marginBottom: '10px',
  },
  fieldsRow: {
    marginBottom: '15px',
  },
  item: {
    borderBottom: '1px solid rgba(0,0,0,0.1)',
    padding: '7px 24px 5px',
    color: 'rgba(0,0,0,0.5)',
    fontSize: '12px',
  },
  reportWrapper: {
    padding: 0,
    maxHeight: 'calc(100vh - 100px)',
    overflowY: 'scroll',
    margin: 0,
    width: '100%',
  },
  arrowIcon: {
    flex: 1,
    padding: 0,
    textAlign: 'right',
    fontSize: '24px',
  },
};

const wStyles = (theme) => ({
  expansionPanelRoot: {
    border: '1px solid rgba(0,0,0,.125)',
    boxShadow: 'none',
    '&:not(:last-child)': {
      borderBottom: 0,
    },
    '&:before': {
      display: 'none',
    },
  },
  expansionPanelExpanded: {
    margin: 'auto',
  },
  greenSummaryRoot: {
    color: 'green',
    backgroundColor: 'rgba(0,0,0,.03)',
    borderBottom: '1px solid rgba(0,0,0,.125)',
    marginBottom: -1,
    minHeight: 56,
    '&$expanded': {
      minHeight: 56,
    },
  },
  redSummaryRoot: {
    color: 'red',
    backgroundColor: 'rgba(0,0,0,.03)',
    borderBottom: '1px solid rgba(0,0,0,.125)',
    marginBottom: -1,
    minHeight: 56,
    '&$expanded': {
      minHeight: 56,
    },
  },
  summaryContent: {
    '&$expanded': {
      margin: '12px 0',
    },
  },
  summaryExpanded: {},
  detailsRoot: {
    padding: 0,
  },
});

const NOT_DELIVERED_PANEL = 0;
const DELIVERED_PANEL = 1;

class NoticeDeliveryReport extends Component {
  state = {
    expanded: NOT_DELIVERED_PANEL,
    selectedPropertiesMultiSelect: [],
    successfullyDelivered: [],
    failedToDeliver: [],
  };

  onPropertySelect = (properties) => {
    const propertyIds = properties.map((multiselectItem) => multiselectItem.value);
    this.setState({
      selectedPropertiesMultiSelect: properties,
      successfullyDelivered: this.props.report.delivered.filter((report) =>
        propertyIds.includes(report.property_id)
      ),
      failedToDeliver: this.props.report.not_delivered.filter((report) =>
        propertyIds.includes(report.property_id)
      ),
    });
  };

  handleChange = (panel) => (event, expanded) => {
    this.setState({
      expanded: expanded ? panel : false,
    });
  };

  downloadHandover = (e) => {
    e.stopPropagation();
    const propertyIds = this.state.selectedPropertiesMultiSelect.map(
      (multiselectItem) => multiselectItem.value
    );
    this.props.downloadTargetedPdf(propertyIds);
  };

  render() {
    return (
      <BodyContent>
        {this.renderPropertyField()}
        <Fragment>
          <div className="row" style={styles.sectionHeader}>
            <div className="col-xs-12">
              <p style={{ margin: '0', textAlign: 'center' }}>
                {this.props.translate('landlordPortal.noticeDeliveryReport.reportUpcase')}
              </p>
            </div>
          </div>

          <div className="row" style={styles.fieldsRow}>
            <div className="col-xs-12" style={{ margin: 'auto' }}>
              {this.renderReport()}
            </div>
          </div>
        </Fragment>
      </BodyContent>
    );
  }

  renderPropertyField = () => {
    return (
      <Fragment>
        <div className="row" style={styles.sectionHeader}>
          <div className="col-xs-12">
            <p style={{ margin: '0', textAlign: 'center' }}>
              {this.props.translate('landlordPortal.noticeDeliveryReport.propertiesUpcase')}
            </p>
          </div>
        </div>

        <div className="row" style={styles.fieldsRow}>
          <div className="col-xs-12" style={{ margin: 'auto' }}>
            <MultiSelectExtended
              hintText={
                this.props.translate('landlordPortal.noticeDeliveryReport.properties').props
                  .children
              }
              data={this.props.properties}
              multiple
              innerDivStyle={{
                width: '100%',
                fontSize: '15px',
                fontWeight: '100 !important',
              }}
              menuStyle={{ minWidth: '250px', fontSize: '15px' }}
              style={{ fontSize: '15px' }}
              fullWidth
              withResetSelectAllButtons
              value={this.state.selectedPropertiesMultiSelect}
              onChange={this.onPropertySelect}
            />
          </div>
        </div>
      </Fragment>
    );
  };

  renderReport = () => {
    const { classes } = this.props;
    const { expanded } = this.state;

    if (this.state.selectedPropertiesMultiSelect.length === 0)
      return (
        <div>{this.props.translate('landlordPortal.noticeDeliveryReport.selectProperties')}</div>
      );

    return (
      <Fragment>
        <ExpansionPanel
          square
          expanded={expanded === NOT_DELIVERED_PANEL}
          onChange={this.handleChange(NOT_DELIVERED_PANEL)}
          classes={{ root: classes.expansionPanelRoot, expanded: classes.expansionPanelExpanded }}
        >
          <ExpansionPanelSummary
            classes={{
              root: classes.redSummaryRoot,
              expanded: classes.summaryExpanded,
              content: classes.summaryContent,
            }}
          >
            {`${
              this.props.translate('landlordPortal.noticeDeliveryReport.failedToDeliever').props
                .children
            } (${this.state.failedToDeliver.length} ${
              this.props.translate('landlordPortal.noticeDeliveryReport.units').props.children
            })`}
            <span style={styles.arrowIcon}>
              {expanded === NOT_DELIVERED_PANEL ? <UpArrow /> : <DownArrow />}
            </span>
          </ExpansionPanelSummary>
          <ExpansionPanelDetails className={classes.detailsRoot}>
            <div class="container" style={styles.reportWrapper}>
              {this.state.failedToDeliver.map((report) => {
                return (
                  <div className="row">
                    <div className="col-xs-12" style={styles.item}>
                      {this.props.translate('landlordPortal.noticeDeliveryReport.unit')}{' '}
                      {report.unit_number} - {report.property_name}
                    </div>
                  </div>
                );
              })}

              {this.state.failedToDeliver.length > 0 && (
                <div className="row">
                  <div className="col-xs-12" style={{ textAlign: 'center', padding: '15px' }}>
                    <FlatButton
                      label={
                        this.props.translate(
                          'landlordPortal.noticeDeliveryReport.downloadTargetedNotice'
                        ).props.children
                      }
                      onClick={this.downloadHandover}
                      disabled={this.state.failedToDeliver.length === 0}
                      primary={true}
                      backgroundColor={AccentColor()}
                      hoverColor="grey"
                      style={{
                        color: colors.WHITE,
                        height: '28px',
                        lineHeight: '28px',
                      }}
                      labelStyle={{ fontSize: '11px' }}
                    />
                  </div>
                </div>
              )}
            </div>
          </ExpansionPanelDetails>
        </ExpansionPanel>
        <ExpansionPanel
          square
          expanded={expanded === DELIVERED_PANEL}
          onChange={this.handleChange(DELIVERED_PANEL)}
          classes={{ root: classes.expansionPanelRoot, expanded: classes.expansionPanelExpanded }}
        >
          <ExpansionPanelSummary
            classes={{
              root: classes.greenSummaryRoot,
              expanded: classes.summaryExpanded,
              content: classes.summaryContent,
            }}
          >
            {`${
              this.props.translate('landlordPortal.noticeDeliveryReport.successfullyDelievered')
                .props.children
            } (${this.state.successfullyDelivered.length} ${
              this.props.translate('landlordPortal.noticeDeliveryReport.units').props.children
            })`}
            <span style={styles.arrowIcon}>
              {expanded === DELIVERED_PANEL ? <UpArrow /> : <DownArrow />}
            </span>
          </ExpansionPanelSummary>
          <ExpansionPanelDetails className={classes.detailsRoot}>
            <div class="container" style={styles.reportWrapper}>
              {this.state.successfullyDelivered.map((report) => {
                return (
                  <div className="row">
                    <div className="col-xs-12" style={styles.item}>
                      {this.props.translate('landlordPortal.noticeDeliveryReport.unit')}{' '}
                      {report.unit_number} - {report.property_name}
                    </div>
                  </div>
                );
              })}
            </div>
          </ExpansionPanelDetails>
        </ExpansionPanel>
      </Fragment>
    );
  };
}

export default withStyles(wStyles)(localize()(NoticeDeliveryReport));
